import { twJoin } from 'tailwind-merge';

import Box from 'shopper/components/Box';

const CommentsListSection = ({ children, className }) => (
  <Box
    as="section"
    className={twJoin('flex gap-4 bg-neutral-high-100 lg:w-[550px]', className)}
  >
    {children}
  </Box>
);

export default CommentsListSection;
